import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import SEO from '../components/SEO';
import SearchContainer from './search/SearchContainer';

const Search: React.FC = () => {
  return (
    <SEO title="Search" description="">
      <Container>
        <Row>
          <Col>
            <SearchContainer />
          </Col>
        </Row>
      </Container>
    </SEO>
  );
};

export default Search;
